var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupporticon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: -1.5,
    width: 97,
    height: 97,
    rx: 8.5,
    transform: "matrix(1 0 0 -1 0 97)",
    fill: "white",
    stroke: "#339999",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 38.75V70.25",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 50H64.5",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 41H64.5",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 63.5C30.1533 63.5 29.581 63.2629 29.159 62.841C28.7371 62.419 28.5 61.8467 28.5 61.25V32C28.5 31.4033 28.7371 30.831 29.159 30.409C29.581 29.9871 30.1533 29.75 30.75 29.75H42C44.3869 29.75 46.6761 30.6982 48.364 32.386C50.0518 34.0739 51 36.3631 51 38.75C51 36.3631 51.9482 34.0739 53.636 32.386C55.3239 30.6982 57.6131 29.75 60 29.75H71.25C71.8467 29.75 72.419 29.9871 72.841 30.409C73.2629 30.831 73.5 31.4033 73.5 32V61.25C73.5 61.8467 73.2629 62.419 72.841 62.841C72.419 63.2629 71.8467 63.5 71.25 63.5H57.75C55.9598 63.5 54.2429 64.2112 52.977 65.477C51.7112 66.7429 51 68.4598 51 70.25C51 68.4598 50.2888 66.7429 49.023 65.477C47.7571 64.2112 46.0402 63.5 44.25 63.5H30.75Z",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 50H42",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 41H42",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupporticon);
export default __webpack_public_path__ + "static/media/Supporticon.5a5d2261a59ae9cae983ccf55bf59724.svg";
export { ForwardRef as ReactComponent };